export default {"src":"/_next/static/media/linkedin.f94fe3b0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};